export default __webpack_public_path__ + "static/media/Sumitomo_Corp.39cb7d29.png";